"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useLauPolygon_1 = __importDefault(require("./hooks/useLauPolygon"));
const tech_1 = require("../../../tech");
function LauContainer({ hidePolygon = false, autoFocus = true, ...props }) {
    const { activeLau } = (0, tech_1.useAuth)();
    const stop = (0, react_1.useMemo)(() => activeLau === undefined, [activeLau]);
    const [lauPolygon, setLauPolygon] = (0, react_1.useState)();
    const setLauPolygonHandler = (polygon) => {
        setLauPolygon(polygon);
        props.setPolygon?.(polygon);
    };
    (0, react_1.useEffect)(() => {
        if (!lauPolygon)
            return;
        lauPolygon.setActive(true);
    }, [lauPolygon, hidePolygon]);
    const message = "Neznámé číslo LAU";
    const fetchLauPolygon = (0, useLauPolygon_1.default)();
    const addPolygon = (map) => {
        if (!activeLau) {
            console.error("No active lau (map)");
            return;
        }
        fetchLauPolygon(activeLau.id).then((data) => {
            const lauPolygon = map.createGeometry(data, "polygon");
            lauPolygon?.setStyle({ color: "red", weight: 4, fillOpacity: 0 });
            lauPolygon.initialize();
            lauPolygon.svgPathHtmlElement.style.pointerEvents = "none";
            setLauPolygonHandler(lauPolygon);
            if (autoFocus)
                map.map?.fitBounds(lauPolygon?.getLeafletObject().getBounds());
        });
    };
    (0, react_1.useEffect)(() => {
        if (lauPolygon)
            return;
        if (props.map.initialized) {
            addPolygon(props.map);
        }
        else {
            props.map.addListener({
                onLoad: addPolygon
            });
        }
    }, []);
    return stop ? ((0, jsx_runtime_1.jsx)("div", { style: {
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }, children: (0, jsx_runtime_1.jsx)("strong", { children: message }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [" ", props.children, " "] }));
}
exports.LauContainer = LauContainer;
